// Slider de opacidad de la marca de agua (logo y texto). Controlado, 0..100 en
// la UI ↔ 0..1 en la capa. `onCommit` dispara una vez al soltar (checkpoint).

interface Props {
  /** 0..1 */
  value: number;
  onChange: (v: number) => void;
  onCommit?: () => void;
}

export function OpacitySlider({ value, onChange, onCommit }: Props) {
  const pct = Math.round(value * 100);
  return (
    <div className="flex flex-col gap-1.5 w-full">
      <div className="flex items-center justify-between">
        <span className="text-[13px] text-neutral-600">Opacidad</span>
        <span className="text-[12px] tabular-nums text-neutral-700">{pct}%</span>
      </div>
      <input
        type="range"
        min={0}
        max={100}
        value={pct}
        onChange={(e) => onChange(Number(e.target.value) / 100)}
        onPointerUp={() => onCommit?.()}
        onKeyUp={() => onCommit?.()}
        className="w-full accent-brand-primary"
        aria-label="Opacidad"
      />
    </div>
  );
}
